import { gql } from '@apollo/client';

export const SAVE_DEEP_LINK = gql`
  mutation saveDeepLink($saveDeepLinkInput: SaveDeepLinkInput!) {
    saveDeepLink(saveDeepLinkInput: $saveDeepLinkInput) {
      message
    }
  }
`;
